import { Tag } from '@dev-spendesk/grapes';
import { useState } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import placeholderImageSource from './assets/placeholder.png';
import { VideoPageModal } from '../../../VideoPageModal';
import { type VideoPageModalProps } from '../../../VideoPageModal/types';

export const VideoBanner = ({
  title,
  url,
}: Pick<VideoPageModalProps, 'title' | 'url'>) => {
  const { t } = useTranslation('global');

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className="flex items-center justify-between gap-16 rounded-12 bg-background-secondary-default p-24">
        <div className="flex flex-col gap-16">
          <p className="flex items-center gap-8 body-xl">
            <span>{t('misc.needHelp')}</span>
            <Tag variant="pink">
              {t('onboardingHub.misc.timeNeeded', { minutes: 2 })}
            </Tag>
          </p>
          <p className="text-content-secondary-bg-primary body-m">
            {t('setupHub.accounting.help.description')}
          </p>
        </div>
        <button
          aria-label={t('misc.needHelp')}
          className="cursor-pointer border-0 transition-transform hover:scale-105"
          onClick={() => setIsModalOpen(true)}
          type="button"
        >
          <img className="w-[126px]" src={placeholderImageSource} alt="" />
        </button>
      </div>
      <VideoPageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
        url={url}
      />
    </>
  );
};
